import { Container, Label, MultiSelect } from './styled'
import { MultiProps } from './type'

export const Multi = ({
  label,
  value,
  onChange,
  loadOptions,
  isMulti = true,
  closeMenuOnSelect = false,
  ...props
}: MultiProps) => {
  return (
    <Container>
      <Label htmlFor={label}>{label}</Label>
      <MultiSelect
        value={value}
        loadOptions={loadOptions}
        closeMenuOnSelect={closeMenuOnSelect}
        onChange={onChange}
        placeholder={`Selecione ${label.toLowerCase()}`}
        isMulti={isMulti}
        {...props}
      />
    </Container>
  )
}
